import React from "react";

export const Overline = ({ children, className = "" }) => (
  <div className={`overline ${className}`}>{children}</div>
);

export const Card = ({ children, className = "", ...rest }) => (
  <div className={`bg-panel border border-line rounded-2xl p-5 sm:p-6 ${className}`} {...rest}>{children}</div>
);

export function Btn({ variant = "primary", as = "button", className = "", children, ...rest }) {
  const base = "inline-flex items-center justify-center gap-2 h-[54px] px-7 rounded-full text-sm font-semibold transition-all duration-200 disabled:opacity-45 active:scale-[0.99]";
  const variants = {
    primary: "bg-gold text-surface hover:bg-golddeep",
    outline: "border border-linestrong text-ink hover:bg-panel",
    ghost: "text-inkfaint hover:text-ink",
    danger: "bg-emerror text-ink hover:opacity-90",
  };
  const cls = `${base} ${variants[variant]} ${className}`;
  const Cmp = as;
  return <Cmp className={cls} {...rest}>{children}</Cmp>;
}

export function Field({ label, hint, textarea, className = "", inputClassName = "", ...rest }) {
  const cls = `w-full bg-panel border border-line rounded-xl px-4 py-3 text-ink placeholder:text-faint focus:border-gold transition-colors ${inputClassName}`;
  return (
    <label className={`block ${className}`}>
      {label && <span className="block text-[13px] text-inkfaint mb-2">{label}</span>}
      {textarea ? (
        <textarea className={`${cls} min-h-[140px] leading-relaxed resize-y`} {...rest} />
      ) : (
        <input className={cls} {...rest} />
      )}
      {hint && <span className="block text-xs text-faint mt-1">{hint}</span>}
    </label>
  );
}
